var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-len */
import React from "react";
import id from "@irati/utils/id";
import BaseSvgIcon from "./Base";
var SummaryTrophies = function (props) {
    var titleId = id("title", props);
    var title = props.title, rest = __rest(props, ["title"]);
    return (React.createElement(BaseSvgIcon, __assign({}, rest, { "aria-labelledby": titleId }),
        React.createElement("path", { d: "m9 12.0091434-4.42182534 3.076977 1.55995986-5.15624394-4.29279821-3.25456761 5.38593356-.10975703 1.76873013-5.08841042 1.7687301 5.08841042 5.3859336.10975703-4.2927982 3.25456761 1.5599598 5.15624394z", fill: "#26b4ae", stroke: "#3d3d36" })));
};
SummaryTrophies.defaultProps = {
    id: "summary-trophy-icon",
    title: "Trophies"
};
export default SummaryTrophies;
